import { render, staticRenderFns } from "./OutsourceSearchBar.vue?vue&type=template&id=bb056644"
import script from "./OutsourceSearchBar.vue?vue&type=script&lang=js"
export * from "./OutsourceSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports